import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Select, Space, Modal, Dropdown } from "antd";
import {
  SearchOutlined,
  DeleteOutlined,
  FileDoneOutlined,
  PlusOutlined,
  SyncOutlined,
  DownloadOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { ModalCadLotes } from "./components/lotesCadastro";
import http from "../../../services/http";
import dayjs from "dayjs";
import { downloadCSV } from "../../../helpers/export-csv";

// STATUS
const options_status = [
  { value: 0, label: "Aguardando" },
  { value: 1, label: "Em Produção" },
  { value: 2, label: "Recebido Parcial" },
  { value: 3, label: "Recebido" },
  { value: 999, label: "Todos" },
];

const status = ["Aguardando", "Em Produção", "Recebido Parcial", "Recebido"];

export const UniformesLotesProducao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // FILTRO STATUS
  const [filtroStatus, setFiltroStatus] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarLotes(filtroStatus);
  }, [filtroStatus]);

  // LISTAR
  const listarLotes = async (filtro_status) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_lotes/listar?status=${filtro_status}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarLote = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_lotes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarLotes(filtroStatus);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RELATÓRIO
  const baixarRelatorio = async (id) => {
    setLoading(true);
    const api = await http("file", `v1/uniformes_lotes/relatorio/${id}`, []);
    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RELATÓRIO
  const baixarRelatorioResumido = async (id) => {
    setLoading(true);
    const api = await http("file", `v1/uniformes_lotes/relatorio-resumido/${id}`, []);
    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const baixarRelatorioCsv = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_lotes/relatorio_csv/${id}`, []);
    if (api.statusCode === 200) {
      console.log(api.response.data);
      downloadCSV(api.response.data, "relatorio_uniformes");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ENVIAR P/ PRODUÇÃO
  const enviarProducao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_lotes/enviar_producao`, {
      id: id,
    });
    if (api.statusCode === 200) {
      message.success("Lote enviado para produção!");
      listarLotes(filtroStatus);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Nº",
      dataIndex: "id",
      sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
    },
    {
      title: "Código",
      dataIndex: "codigo",
      sorter: (a, b) => a.codigo?.toString()?.localeCompare(b.codigo?.toString()),
    },
    {
      title: "Fornecedor",
      dataIndex: "fornecedor",
      sorter: (a, b) => a.fornecedor?.localeCompare(b.fornecedor),
    },
    {
      title: "Pedido",
      dataIndex: "quantidade",
      sorter: (a, b) => a.quantidade?.toString()?.localeCompare(b.quantidade?.toString()),
    },
    {
      title: "Qtd. Recebida",
      dataIndex: "qtd_recebida",
      sorter: (a, b) => a.qtd_recebida?.toString()?.localeCompare(b.qtd_recebida?.toString()),
    },
    {
      title: "Data",
      dataIndex: "data",
      render: (_, e) => dayjs(e?.data_lancamento).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a?.data_lancamento).format("DD/MM/YYYY")?.localeCompare(dayjs(b?.data_lancamento).format("DD/MM/YYYY")),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => status[e.status],
      sorter: (a, b) => status[a.status]?.localeCompare(status[b.status]),
    },
    {
      title: "Ações",
      width: 80,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Baixar CSV">
            <Button loading={loading} onClick={() => baixarRelatorioCsv(e.id)} icon={<FileExcelOutlined />} />
          </Tooltip>

          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label: "Relatório por pessoa",
                  icon: <DownloadOutlined />,
                  onClick: () => baixarRelatorio(e.id),
                },
                {
                  key: "2",
                  label: "Relatório por produto",
                  icon: <DownloadOutlined />,
                  onClick: () => baixarRelatorioResumido(e.id),
                },
              ],
            }}>
            <Button loading={loading} icon={<DownloadOutlined />} />
          </Dropdown>
          {e?.status !== 0 && (
            <Tooltip title="Recebimentos">
              <Button
                loading={loading}
                onClick={() => navigate(`/uniformes/pedidos-recebidos/${e.id}`)}
                icon={<FileDoneOutlined />}
              />
            </Tooltip>
          )}

          {e?.status === 0 && (
            <React.Fragment>
              <Tooltip title="Excluir">
                <Button
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja deletar este registro?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        deletarLote(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>

              <Tooltip title="Enviar para produção">
                <Button
                  loading={loading}
                  icon={<SyncOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja enviar para produção?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        enviarProducao(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>
            </React.Fragment>
          )}
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.codigo?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.fornecedor?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.id?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val?.data_lancamento).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // CLOSE MODAL
  const handleModalClose = () => {
    setShowModal(false);
    listarLotes(filtroStatus);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <ModalCadLotes showModal={showModal} onClose={handleModalClose} />
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Uniformes Lotes"
              subtitle="Gerenciar Lotes Para Produção"
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Select
                  style={{ minWidth: 180 }}
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e)}
                  options={options_status}
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowModal(true)} loading={loading}>
                  Criar Lote
                </Button>
                <Button
                  type="text"
                  icon={<OrderedListOutlined />}
                  onClick={() => navigate("/uniformes/pedidos-recebidos")}
                  loading={loading}>
                  Pedidos Recebidos
                </Button>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
